import Navigation from "./features/navigation";
import Animations from "./features/animations";
import Comments from "./features/comments";
import Search from "./features/search";
import Forms from "./features/forms";
import License, { isLicenseActive } from "./features/license";
import { initializeScriptTracker } from "./utils/utils";


(() => {
    /**
     * Initialize script tracker to prevent re-execution of existing scripts.
     */
    initializeScriptTracker()

    /**
     * License validation - must run first.
     */
    License()

    // Check if license is active.
    const is_license_active = isLicenseActive()

    /**
     * Navigation & Animations
     */
    if ( ajaxpress_vars.settings.enable_navigation ) {
        Navigation()
        Animations()
    }

    /**
     * Comments.
     */
    if ( ajaxpress_vars.settings.enable_comments ) {
        Comments()
    }

    /**
     * Search (Premium feature).
     */
    if ( ajaxpress_vars.settings.enable_search && is_license_active ) {
        Search()
    }

    /**
     * Forms (Premium feature).
     */
    if ( ajaxpress_vars.settings.enable_forms && is_license_active ) {
        Forms()
    }
})()